import { BaseType } from '../../../../../../models/base/base-type';
import { EmployerStatusTypeEnum } from '../enum/employer-status-type-enum';

export class EmployerStatusType extends BaseType {
  // @ts-ignore
  public id!: EmployerStatusTypeEnum;
}
